import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import { TagHighlightType } from '@design-system/components/molecules/tag-highlight/entities/tag-highlight.types';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';

@Component({
  selector: 'app-ds-tag-highlight',
  templateUrl: './tag-highlight.component.html',
  styleUrls: ['./tag-highlight.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TypographyDsComponent,
    IconDsComponent,
  ]
})
export class TagHighlightDsComponent {

  @Input() type = TagHighlightType.Hot;
  @Input() title: string;
  @Input() description: string;

  public readonly fontFamily = TypographyFontFamily;
  public readonly fontColor = TypographyColor;

  constructor() { }

  get useText(): boolean {
    return this.type !== TagHighlightType.Hot;
  }

  get useDescription(): boolean {
    return this.type === TagHighlightType.Opinion;
  }

  get titleFontSize(): TypographyFontSize {
    return this.type === TagHighlightType.Protection ? TypographyFontSize.XXXS : TypographyFontSize.XXS;
  }

  get descriptionFontSize(): TypographyFontSize {
    return this.type === TagHighlightType.Opinion ? TypographyFontSize.Minor : null;
  }

  get tagIcon(): Icon {
    switch (this.type) {
      case TagHighlightType.Hot:
        return Icon.HotOutline;
      case TagHighlightType.Protection:
        return Icon.CheckProtection;
      default:
        return Icon.Trophy;
    }
  }

  get iconSize(): number {
    switch (this.type) {
      case TagHighlightType.Hot:
        return 20;
      case TagHighlightType.Protection:
        return 16;
      default:
        return 24;
    }
  }

  get iconColor(): IconFillColor {
    switch (this.type) {
      case TagHighlightType.Hot:
        return IconFillColor.Light;
      case TagHighlightType.Protection:
        return IconFillColor.Success;
      default:
        return null;
    }
  }

}
